import { css } from 'styled-components';
import {
  BreakpointQueryName, ThemedFunctor,
} from '@doveit/bricks';

const MOBILE_IMAGE_HEIGHT = '16rem';
const TABLET_IMAGE_HEIGHT = '29.5rem';

const MOBILE_MESH_ANGLE_DEG = '176.5deg';
const DESKTOP_MESH_ANGLE_DEG = '-79.5deg';

const BACKGROUND_SECONDARY_GRADIENT = '#af4082';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  padding: calc(${theme.spaceUnits.mobile.BIG} + ${MOBILE_IMAGE_HEIGHT}) 0 ${theme.spaceUnits.mobile.BIGGER};
  position: relative;
  color: ${theme.palettes.neutrals.lightest};
  background-color: ${BACKGROUND_SECONDARY_GRADIENT};

  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(${MOBILE_MESH_ANGLE_DEG}, rgba(0, 0, 0, 0) ${MOBILE_IMAGE_HEIGHT}, ${BACKGROUND_SECONDARY_GRADIENT} ${MOBILE_IMAGE_HEIGHT}, ${theme.palettes.brand.primary} 22rem, ${theme.palettes.brand.primary});

    ${theme.breakpoints.up(BreakpointQueryName.MD)} {
      background: linear-gradient(${MOBILE_MESH_ANGLE_DEG}, rgba(0, 0, 0, 0) ${TABLET_IMAGE_HEIGHT}, ${BACKGROUND_SECONDARY_GRADIENT} ${TABLET_IMAGE_HEIGHT}, ${theme.palettes.brand.primary} 22rem, ${theme.palettes.brand.primary});
    }

    ${theme.breakpoints.up(BreakpointQueryName.LG)} {
      background: linear-gradient(${DESKTOP_MESH_ANGLE_DEG}, rgba(0, 0, 0, 0) 35%, ${BACKGROUND_SECONDARY_GRADIENT} 35%, ${theme.palettes.brand.primary} 60%, ${theme.palettes.brand.primary});
    }
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: calc(${theme.spaceUnits.mobile.BIG} + ${TABLET_IMAGE_HEIGHT}) 0 ${theme.spaceUnits.mobile.BIGGER};
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    padding: ${theme.spaceUnits.desktop.BIGGER} 0;
    min-height: 25rem;
  }
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.neutrals.lightest};
  position: relative;
  z-index: 2;
`;

export const cover: ThemedFunctor = ({
  theme,
  $mobileCover,
  $desktopCover,
  $coverPosition,
}) => css`
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  left: 0;
  height: ${MOBILE_IMAGE_HEIGHT};
  background: url('${$mobileCover}') no-repeat;
  background-size: cover;
  background-position: ${$coverPosition};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    height: ${TABLET_IMAGE_HEIGHT};
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    left: auto;
    height: auto;
    bottom: 0;
    background-image: url('${$desktopCover}');
    width: 40%;
  }
`;
